import request, { METHODS } from "src/utils/api-base";

const tenantUserApis = {
  createTenantUser: (payload: any) => {
    const { isAdminAuth, tenantId, ...data } = payload || {};
    return request({
      route: isAdminAuth
        ? `/admin/tenant/users/${tenantId}/create`
        : "/app/tenant-user/create",
      method: METHODS.POST,
      payload: data,
      auth: true,
      isAdminAuth,
    });
  },
  editTenantUser: (payload: any) => {
    const { isAdminAuth, tenantId, ...data } = payload || {};
    return request({
      route: isAdminAuth
        ? `/admin/tenant/users/${tenantId}/${payload._id}`
        : `/app/tenant-user/${payload._id}`,
      method: METHODS.PUT,
      payload: data,
      auth: true,
      isAdminAuth,
    });
  },
  getTenantUserList: (params: {
    page?: number;
    limit: number;
    search?: string;
    role?: string;
    departmentId?: string;
    status?: "active" | "suspended";
    tenantId?: string;
    isAdminAuth?: boolean;
  }) => {
    const { isAdminAuth, tenantId, ...query } = params || {};
    return request({
      route: isAdminAuth
        ? `/admin/tenant/users/${tenantId}/list`
        : "/app/tenant-user/list",
      method: METHODS.GET,
      params: query,
      auth: true,
      isAdminAuth,
    });
  },
  changeTenantUserPassword: (payload: any) => {
    return request({
      route: `/app/tenant-user/change-password`,
      method: METHODS.PUT,
      payload,
      auth: true,
    });
  },
};

export default tenantUserApis;
